import styled from "styled-components";

export const SettingsWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grayL5 || "#CCCCCC"};
  border-radius: 3px;
  width: 100%;
  margin-left: 0% !important;
  @media (max-width: 768px) {
    margin-bottom: 20px;
    width: 100%;
  }
`;

export const SettingsContainer = styled.div`
  overflow: hidden;
  height: calc(100vh - 380px);
  overflow: auto;

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: ${({ theme }) => theme.colors.grayL6 || "#F2F2F2"};
  }

  ::-webkit-scrollbar {
    width: 6px;
    background-color: green !important;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.grayL4 || "#9A9A9A"};
  }
  @media (max-width: 768px) {
    height: auto;
  }
`;

export const SettingsContainerAS = styled.div`
  overflow: hidden;
  height: calc(100vh - 245px);
  overflow: auto;
  @media (max-width: 768px) {
    height: auto;
  }
`;

export const OnOffText = styled.div`
  margin: 0rem 0px 0 0;
  font-family: "Open Sans", sans-serif;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
`;

export const OnOffTextDiv = styled.div`
  margin: 0rem 10px 0 0;
  font-family: "Open Sans", sans-serif;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
`;

export const SettingsFooter = styled.div`
  overflow: hidden;
  width: 94%;
  margin: 15px auto;
  text-align: left;
  .update-button-s2 {
    margin: 0px !important;
    padding: 0px !important;
    width: 100%;
    display: flex;
    .worksite-names {
      padding-right: 0px;
      flex: 1;
      float: left;
      text-align: left;
      display: block !important;
      max-width: initial;
      padding: 0px !important;
    }
    .col-md-8 {
      padding-right: 0px;
      flex: 1;
    }

    @media (max-width: 430px) {
      .worksite-names button {
        padding: 6px 7px;
      }
      .col-md-8 button {
        padding: 6px 7px;
      }
      .apptoall {
        position: relative;
        right: 0;
        left: 100px;
        width: 230px;
      }
    }
  }
`;

export const SettingsBody = styled.div`
  width: 94%;
  margin: 10px auto;
  text-align: left;
`;

export const SettingsHeaderTop = styled.div`
  font-family: "kanit";
  font-size: 18px !important;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  margin-bottom: 0.2rem;
  @media (max-width: 768px) {
    font-size: 15px !important;
  }
`;

export const SettingDescription = styled.div`
  font-size: 14px !important;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  font-family: "Open Sans", sans-serif;
`;

export const SettingTableDescription = styled.div``;
export const RowDiv = styled.div`
  display: grid;
  grid-template-columns: 65% 15% 5% 15%;
  height: 36px;
  @media (max-width: 1100px) {
    grid-template-columns: 38% 28% 3% 31%;
    margin-bottom: ${({ isHeader }) => (isHeader ? "0px" : "25px")};
    height: auto;
  }
`;

export const Column = styled.div`
  padding: ${({ isHeader }) => (isHeader ? "8px 0px" : "0px")};
  color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
  font-size: ${({ isHeader }) => (isHeader ? "18px" : "14px")} !important;
  font-family: ${({ isHeader }) => (isHeader ? "Kanit" : "Open Sans")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
  display: ${({ isHeader }) => (isHeader ? "flex;" : "flow-root;")};
  align-items: center;
  justify-content: left;
  text-align: left;
  label {
    margin: 0 !important;
  }
  @media (max-width: 768px) {
    font-size: ${({ isHeader }) => (isHeader ? "15px" : "13px")} !important;
  }
`;

export const RowsContainer = styled.div`
  max-height: 200px;
  overflow: auto;
  @media (max-width: 1100px) {
    margin-bottom: 50px;
  }
`;

export const SettingDotIconLow = styled.i`
  font-size: 17px;
  color: ${({ theme }) => theme.colors.greenPrimary || "#11A70B"};
  margin: 2px 9px -4px 0px;
  padding: 0;
  float: left;
  @media (max-width: 768px) {
    font-size: 14px;

    margin: 2px 6px -4px 1px;
  }
`;

export const SettingDotIconMed = styled.i`
  font-size: 17px;
  color: ${({ theme }) => theme.colors.orangePrimary || "#DD9000"};
  margin: 2px 9px -4px 0px;
  padding: 0;
  float: left;
  @media (max-width: 768px) {
    font-size: 14px;

    margin: 2px 6px -4px 1px;
  }
`;

export const SettingDotIconHigh = styled.i`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  margin: 2px 9px -4px 0px;
  padding: 0;
  float: left;
  @media (max-width: 768px) {
    font-size: 14px;
    margin: 2px 6px -4px 1px;
  }
`;

export const SettingContent = styled.div`
  font-size: 17px !important;
  display: flex;
  align-items: center;
  height: 35px;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  @media (max-width: 768px) {
    font-size: 14px !important;
  }
`;

export const InputGroupWrapper = styled.div`
  display: flex;
  font-family: "Open Sans";
`;
export const Gtext = styled.div`
  font-size: 16px !important;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  margin: 0px 4px;
  line-height: 26px;
`;

export const RowDivError = styled.div`
  font-size: 16px !important;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  margin: 0px 4px;
  line-height: 26px;
`;

export const ErrorInputNumbers = styled.div`
  font-size: 13px !important;
  color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  line-height: 26px;
  text-align: right;
  font-family: "Open Sans", sans-serif;
`;

export const BorderLineDiv = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayL5 || "#CCCCCC"};
  width: 100%;
  margin: 5px auto;
`;

export const SettingsAlertMessege = styled.div``;

export const ErrorMessageDiv = styled.div`
  font-size: 13px !important;
  color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  line-height: 26px;
  text-align: right;
  font-family: "Open Sans", sans-serif;
`;

export const WarningMessageDiv = styled.div`
  font-size: 13px !important;
  color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  line-height: 26px;
  text-align: left;
  font-family: "Open Sans", sans-serif;
  margin-top: 5px;
`;

export const AlertSettingIcon = styled.i`
  font-size: 17px;
  color: ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  margin: 3px 5px -6px 0px;
  padding: 0px;
  float: left;
`;
export const AndAboveText = styled.div`
  font-size: 13px !important;
  color: ${({ theme }) => theme.colors.grayL3 || "#676767"};
  line-height: 26px;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  margin-top: 5px;
`;

export const WarningMessageText = styled.div``;

export const InformationIconM = styled.i`
  font-size: 17px;
  color: ${({ theme }) => theme.colors.grayL3 || "#676767"};
  margin: 3px 5px -6px 0px;
  padding: 0px;
  float: left;
`;
export const InformationTextM = styled.div`
  font-size: 13px !important;
  color: ${({ theme }) => theme.colors.grayL3 || "#676767"};
  line-height: 26px;
  text-align: left;
  font-family: "Open Sans", sans-serif;
  margin-top: 5px;
`;
export const InformationMessage = styled.div``;

export const ImageTextContainer = styled.div`
  float: left;
  padding-top: 15px;
  width: 100%;
  padding-bottom: 20px;
`;
export const TextBoxLeft = styled.div`
  float: left;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
`;
export const ImageForkliftRight = styled.div`
  float: left;
  margin-left: 60px;
  img {
    width: 300px;
  }
  @media (max-width: 1100px) {
    margin-top: 10px;
    margin: auto;
    width: auto;
  }
  @media (max-width: 700px) {
    img {
      margin-top: 10px;
    }
  }
`;

export const LowTextBox = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.greenPrimary || "#11A70B"};
  padding: 2px 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  float: left;
  clear: both;
`;
export const MediumTextBox = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.orangePrimary || "#DD9000"};
  padding: 2px 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  float: left;
  clear: both;
`;
export const HighTextBox = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.redPrimary || "#DD0000"};
  padding: 2px 10px;
  border-radius: 4px;
  float: left;
  clear: both;
`;

/* Access Control Setting Styles */

export const AccessControlSetting = styled.div``;
export const HeadingTabACS = styled.div`
  padding: 8px 0px;
  color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
  font-family: Kanit;
  align-items: center;
  justify-content: left;
  text-align: left;
  font-size: 18px !important;
`;
export const ACSSecondDiv = styled.div`
  display: flex;
`;
export const LeftDivACS = styled.div`
  flex: 1;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  font-family: "Open Sans", sans-serif;
  font-size: 16px !important;
  text-align: left;
  line-height: 40px;
`;
export const RightSwitchDiv = styled.div`
  flex: 1;
  text-align: right;
  display: flex;
  justify-content: end;
  span {
    /* margin-right: 3px;*/
  }
  label {
    margin: 0px !important;
  }
`;
export const ThirdACSDiv = styled.div`
  display: flex;
  @media (max-width: 768px) {
    display: block;
  }
`;
export const LeftACSDiv = styled.div`
  flex: 1;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.grayL3 || "#676767"};
  font-family: "Open Sans", sans-serif;
  font-size: 14px !important;
  text-align: left;
  line-height: 31px;
  span {
    position: relative;
    top: -3px;
  }
`;
export const IconTimer = styled.i`
  font-size: 17px;
  margin-right: 3px;
`;
export const RightACSDiv = styled.div`
  text-align: right;
  display: flex;
  justify-content: end;
  span {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.grayL3 || "#676767"};
    font-family: "Open Sans", sans-serif;
    font-size: 14px !important;
    text-align: left;
    line-height: 31px;
    margin-left: 10px;
  }
  @media (max-width: 768px) {
    display: block;
    overflow: hidden;
    justify-content: initial;
    input.form-control {
      width: 80px;
      float: left;
    }
    span {
      float: left;
      margin: 0;
    }
  }
`;

export const InputStyledACS = styled.input`
  display: inline-block;
  position: relative;
  text-align: right;
  width: 120px;
  font-family: "Open Sans", sans-serif;
  height: 32px;
  font-weight: bold;
  font-size: 18px !important;
  margin-right: 10px;
`;

export const SelectStyledACS = styled.select`
  position: relative;
  text-align: center;
  width: 110px;
  font-family: "Open Sans", sans-serif;
  height: 32px;
  font-weight: bold;
  font-size: 16px;
  padding: 0px;
  margin: 0px;
`;

export const CameraTabNavContainer = styled.div`
  position: relative;
  padding: 10px 24px;
  nav a {
    text-transform: uppercase;
  }

  @media (max-width: 768px) {
    font-size: 15px !important;
    a.nav-item {
      padding: 4px 8px;
      font-size: 10px;
      line-height: 24px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .tab-content {
      .s3-setting-tab {
        margin-top: 20px;
        float: left;
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
`;

export const NoAssetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 200px);
  color: ${({ theme }) => theme.colors.grayL3 || "#676767"};
  font-family: "Open Sans", sans-serif;
  font-size: 16px !important;
  margin-bottom: 0px;
  p {
    margin-bottom: 0px;

    height: calc(100vh - 365px);
    display: flex;
    align-items: center;
  }
  @media (max-width: 768px) {
    height: auto;
  }
`;

export const LoaderOverlay = styled.div`
  position: absolute;
  width: -webkit-fill-available;
  height: calc(100vh - 300px);
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;
